module.exports = __webpack_public_path__ + "img/switch_img2.061d4d30.png";